const openQuickShopModal = (product) => {

  // The "product" parameter contains values from the Tolstoy spotlight carousel.

  console.log(product);

  // Please put your functions here

}

 

const subscribeToQuickShopClick = () => {

  window.tolstoyWidget.subscribe(

    "tolstoy_spotlight_carousel_quick_shop_click",

    (o) => {

      o.product && o.product.handle ? openQuickShopModal(o.product) : console.error("Product handle is not available in the event");

    },

    { disableDefault: !0 },

  );

}

 

window.tolstoyWidget ? subscribeToQuickShopClick() : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);